import { render } from "./AddVacancyVideo.vue?vue&type=template&id=063eaef1"
import script from "./AddVacancyVideo.vue?vue&type=script&lang=js"
export * from "./AddVacancyVideo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__